<template>
  <d-container fluid>
    <d-row>
      <!-- Main Sidebar -->
      <main-sidebar :items="sidebarItems" />

      <div
        v-if="!Stripe_client_id"
        :class="(['main-navbar', 'bg-white', 'sticky-top'], 'warning-bar')"
      >Please enter your stripe client id</div>
      <d-col class="main-content offset-lg-1 offset-md-2 p-0" tag="main" lg="11" md="9" sm="12">
        <!-- Main Navbar -->
        <main-navbar />

        <!-- Content -->
        <slot />

        <!-- Main Footer -->
        <main-footer />
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import getSidebarItems from "@/data/sidebar-nav-items";
import settingTypes from "@/vuex/setting/setting.types";
// Main layout components
import MainNavbar from "@/components/layout/MainNavbar/MainNavbar.vue";
import MainSidebar from "@/components/layout/MainSidebar/MainSidebar.vue";
import MainFooter from "@/components/layout/MainFooter/MainFooter.vue";
import { mapState } from "vuex";

export default {
  name: "analytics",
  components: {
    MainNavbar,
    MainSidebar,
    MainFooter
  },
  data() {
    return {
      sidebarItems: getSidebarItems(),
      Stripe_client_id: ""
    };
  },
  computed: {
    ...mapState({
      type: state => state.setting.type,
      data: state => state.setting.data,
      error: state => state.setting.error
    })
  },
  watch: {
    type(type) {
      if (
        type === settingTypes.FETCH_SETTING_SUCCESS ||
        type === settingTypes.UPDATE_SETTING_SUCCESS
      ) {
        if (this.data.setting) {
          const Settings = this.data.setting;
          this.Stripe_client_id = Settings.stripe_client_id;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.warning-bar {
  width: 100%;
  top: 61px;
  background: black !important;
  z-index: 1000;
  height: 28px;
  text-align: center;
  position: fixed;
  color: white;
  line-height: 1.8;
}
</style>
